import { Box, Text } from '@chakra-ui/react';

import { DefaultLayout } from '$components/layout/default-layout';

import { Card, Post } from './card';

export interface PostsTemplateProps {
  posts: Post[];
}

export function PostsTemplate({ posts }: PostsTemplateProps) {
  return (
    <DefaultLayout>
      <Text
        fontFamily="mono"
        fontSize="12px"
        letterSpacing="0.16em"
        textTransform="uppercase"
        color="text.faint"
        mb="16px"
      >
        [ Blog · Postagens ]
      </Text>

      <Box
        as="h1"
        fontFamily="display"
        fontSize={{ base: '56px', md: '88px' }}
        lineHeight="0.95"
        letterSpacing="-0.03em"
        color="text.primary"
        mb="16px"
      >
        Blog
        <Box as="span" color="accent.500">
          .
        </Box>
      </Box>

      <Text
        fontSize={{ base: '16px', md: '17px' }}
        color="text.muted"
        maxW="60ch"
        lineHeight="1.6"
        mb="40px"
      >
        Postagens que escrevo periodicamente, quando dá vontade, normalmente
        sobre algo que aprendi recentemente ou um problema técnico que valeu a
        pena documentar.
      </Text>

      <Box>
        {posts.map((post) => (
          <Card key={post.slug} post={post} />
        ))}
      </Box>
    </DefaultLayout>
  );
}
